import React, { useEffect, useState } from "react";

//CSS
import "./PermissionView.css";

//Components
import PageLoader from "../Other Components/pageLoader";

//Functions and hooks
import { fetchWithTimeout } from "../../hooks/useFetchWithTimeout";
import {
  GetUserPermissions,
  GetAllAvailablePermissions,
} from "../../BackendAccess/UserHooks";
import { useErrorHandler } from "../../hooks/errorHandler";
import { useNotification } from "../../Contexts/NotificationContext";
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import { useTranslation } from "react-i18next";

export default function PermissionView({
  selectable = false,
  initSelection = null,
  setNewSelection = () => {},
  getPermissionsForUser = true,
}) {
  const [permissions, setPermissions] = useState([]);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { showNotification } = useNotification();

  useErrorHandler(error, showNotification, setPageError);

  const isNarrow = useNarrowMode();
  const { t } = useTranslation();

  useEffect(() => {
    GetAndSetUserPermissions();
  }, []);

  const GetAndSetUserPermissions = async () => {
    try {
      setLoading(true);
      console.log("Setting perms: ", selectable, initSelection);
      if (selectable && initSelection) setPermissions(initSelection);
      else {
        const [data, error] = await fetchWithTimeout(
          getPermissionsForUser
            ? GetUserPermissions
            : GetAllAvailablePermissions
        );
        if (error) {
          console.log("Setting perms err1: ", error);

          error.isPageError = true;
          setError(error);
        } else {
          console.log("Setting perms 222: ", selectable, data);

          setPermissions(data);
        }
      }
    } catch (err) {
      console.log("Setting perms err: ", err);

      setError({
        err: t("server.Server error.", { ns: "error" }),
        errCode: 500,
      });
    } finally {
      setLoading(false);
    }
  };

  const onItemClick = (id) => {
    if (!selectable) return;

    const newItems = permissions.map((item) => {
      if (item.PermissionID !== id) return item;
      return { ...item, HasPermission: !item.HasPermission };
    });

    setPermissions(newItems);
    setNewSelection(newItems);
  };

  const onSelectAllClick = () => {
    const allSelected = permissions.every((p) => p.HasPermission);
    const newItems = permissions.map((p) => ({
      ...p,
      HasPermission: !allSelected,
    }));
    setPermissions(newItems);
    setNewSelection(newItems);
  };

  const createItems = (item) => {
    return (
      <li
        key={item.Name}
        className={"permission-item" + (selectable ? " selectable " : "")}
        onClick={() => onItemClick(item.PermissionID)}
      >
        <span className="permission-item-text">
          {t(item.Name, { ns: "roles" })}
        </span>
        {isNarrow ? null : (
          <span className="permission-item-text">
            {t(item.Category, { ns: ["roles", "common"] })}
          </span>
        )}
        <div
          className={"checkbox " + (item.HasPermission ? "checked" : "")}
        ></div>
      </li>
    );
  };

  return (
    <div className="container-bordered permission-view w-90">
      <PageLoader loading={loading} error={pageError}>
        <div className="permission-item header">
          <span className="permission-item-text"> {t("Permission")}</span>
          {isNarrow ? null : (
            <span className="permission-item-text"> {t("Category")}</span>
          )}
          {selectable && (
            <>
              <div
                onClick={onSelectAllClick}
                className={
                  "checkbox " +
                  (permissions.every((p) => p.HasPermission) ? "checked" : "")
                }
              ></div>
            </>
          )}
        </div>
        <ul className="permission-list">{permissions.map(createItems)}</ul>
      </PageLoader>
    </div>
  );
}
